<template>
    <div>
        <help chapitre="ACCUEIL"  />
        <s-button label="save" icon="save" theme="is-primary" @onclick="saveChapitre"/>&nbsp;&nbsp;
        <s-button label="Ajouter" icon="plus" theme="is-primary" @onclick="addChapitre"/>
        <div v-for="(chapitre, indexChapitre) in chapitres.chapitres" class="chapitre">
           <s-button @onclick="displayVideos(chapitre)" 
            :icon=" chapitreCurrent.id == chapitre.id ? 'minus' : 'plus'" label="" 
            :theme=" chapitreCurrent.id == chapitre.id ? 'is-success is-small' : 'is-info is-small'"/>
            
            <div style="float:right;margin:2px"> 
                <s-button @onclick="upChapitre(chapitre.id)" 
                 theme="is-primary" 
                icon="arrow-up" label="" :disabled="indexChapitre==0"/>&nbsp;
                <s-button @onclick="downChapitre(chapitre.id)" 
                theme="is-primary" icon="arrow-down" label="" :disabled="indexChapitre==chapitres.chapitres.length-1" />
            &nbsp;&nbsp;
            <s-button @onclick="removeChapitre(chapitre)" icon="trash" theme="is-danger" label="Supprimer le chapitre"/>&nbsp;&nbsp;
                </div> 
           &nbsp;<s-input width="500px" theme="is-primary" v-model="chapitre.label" placeholder="Nouveau chapitre" /> 
               <s-input width="200px" theme="is-primary" v-model="chapitre.id" placeholder="ID chapitre" /> 
           <div v-show="chapitreCurrent.id == chapitre.id" class="chapitreVideos">
                <s-button label="Ajouter une vidéo" icon="plus" @onclick="openModalVideo(chapitre)" theme="is-info is-small"/>
                <div v-for="(video, indexVideo) in chapitre.videos" class="video">
                    <div style="float:right;margin:2px;"> 
                        <s-button @onclick="upVideo(video.idYouTube)" 
                            theme="is-primary is-small" 
                            icon="arrow-up" label="" :disabled="indexVideo==0"/>&nbsp;
                        <s-button @onclick="downVideo(video.idYouTube)" 
                            theme="is-primary  is-small" icon="arrow-down" label="" :disabled="indexVideo==chapitre.videos.length-1" />
                            
                    &nbsp; <s-button @onclick="removeVideo(video)" icon="trash" theme="is-danger is-small" label="Supprimer la vidéo"/>&nbsp;&nbsp;
                    </div>
                    <s-button @onclick="idYouTubeRead = video.idYouTube" icon="film" theme="is-success is-small" label="Lire la video"/>&nbsp;
                    <s-button @onclick="editVideo(video)" icon="edit" theme="is-info is-small" label="Editer"/>&nbsp;
                    {{video.label}} ({{video.idYouTube}})
                    <s-button icon="film" v-if="video.default" theme="is-small is-warning" label=""/>&nbsp;
                    <s-button icon="euro" v-if="video.credit" theme="is-small is-warning" label=""/>
                </div>
                <div v-if="pasDeVideos(chapitre)">
                    Pas de videos
                </div>
           </div>
        </div>
        {{chapitres}}
        <s-modal
            title="Lire la vidéo"
            :open="idYouTubeRead!=null"
            @close="idYouTubeRead=null"
            :close="true">
            <youtube width="100%" 
                            :video-id="idYouTubeRead" 
                            :player-vars="playerVars"  
                            :ref="idYouTubeRead"
                            @playing="playing"
                            @paused="paused"
                            @ended="ended"></youtube> 
        </s-modal>
        <s-modal 
            title="Ajouter une vidéo"
            :open="modalVideo"
            @close="modalVideo=false"
            :close="true"
            @save="saveVideo"
            :save="true"
           
        >
            Description de la vidéo : <s-input v-model="editVideoJSON.label" placeholder="Nom de la vidéo" theme="is-primary"/>
            ID You Tube : <s-input   theme="is-primary" type="text" v-model="editVideoJSON.idYouTube" placeholder="Id You Tube"/>
            <br/><br/>Lecture par défault : <input   theme="is-primary" type="checkbox" v-model="editVideoJSON.default" /><br/>
            Credit : <input   theme="is-primary" type="checkbox" v-model="editVideoJSON.credit" />

        </s-modal>
    </div>
</template>
<style scoped>
    .chapitre {
        margin: 5px;
        color: black;
        font-size: 20px;
    }
    .chapitreVideos {
        border: thin solid gray;
        margin: 10px;
        padding: 5px;
    }
    .video {
        margin-left: 20px;
        margin-top: 5px;
        font-size: 20px;
    }
</style>
<script>
import firebase_api from "@/firebase/firebase_api"
import help from "@/views/help/help.vue"
export default ({
    components: {
        help
    },
    data() {
        return {
            idYouTubeRead: null,
            modalVideo: false,
            new_chapitre: {
                id: "",
                label: "",
                videos: []
            },
            chapitres: {},
            
            chapitreCurrent: {
                id: null
            },
            idYouTubeEdit: null,
            editVideoJSON: {
                label: "",
                idYouTube: null,
                default: false,
                credit: false
            },
             playerVars: {
                autoplay: 0,
                host: 'https://www.youtube.com',
                autohide: 0,
                fs: 1,
                modestbranding: 0,
                color: 'white',
                iv_load_policy: 3,
                cc_load_policy: 1,
                rel: 0,
                showinfo:1,
                controls:1
            },
        }
    },
    mounted() {
        this.refresh();
    },
    methods: {
        pasDeVideos(chapitre) {
            if (typeof(chapitre.videos)=="undefined")
               return true;
            else 
                return chapitre.videos.length == 0;
        },
        playing() {
            
        },
        paused() {
           
        },
        ended() {
            
        },
        downChapitre(chapitreId) {
            var chapitreIndex = this.chapitres.chapitres.findIndex(chapitre=>chapitre.id === chapitreId);
           
            var chapitreInsert = JSON.parse(JSON.stringify(this.chapitres.chapitres[chapitreIndex]));
            this.chapitres.chapitres.splice(chapitreIndex+2, 0,chapitreInsert);
            this.chapitres.chapitres.splice(chapitreIndex, 1);
            this.saveChapitre();
        },
        upChapitre(chapitreId) {
            var chapitreIndex = this.chapitres.chapitres.findIndex(chapitre=>chapitre.id === chapitreId);
            var chapitreInsert = JSON.parse(JSON.stringify(this.chapitres.chapitres[chapitreIndex]));
            this.chapitres.chapitres.splice(chapitreIndex-1, 0,chapitreInsert);
            this.chapitres.chapitres.splice(chapitreIndex+1, 1);
            this.saveChapitre();
        },
        refresh() {
          firebase_api.api.getDb().collection("videos").doc("chapitres").get().then(res=>{
                 this.chapitres = res.data();
         });
        },
        downVideo(videoId) {
            var chapitreIndex = this.chapitres.chapitres.findIndex(chapitre=>chapitre.id === this.chapitreCurrent.id);
            var videoIndex = this.chapitres.chapitres[chapitreIndex].videos.findIndex(video=>video.idYouTube === videoId);
            var videoInsert = JSON.parse(JSON.stringify( this.chapitres.chapitres[chapitreIndex].videos[videoIndex]));
            this.chapitres.chapitres[chapitreIndex].videos.splice(videoIndex+2, 0,videoInsert);
            this.chapitres.chapitres[chapitreIndex].videos.splice(videoIndex, 1);

            this.saveChapitre();
        },
        upVideo(videoId) {
            var chapitreIndex = this.chapitres.chapitres.findIndex(chapitre=>chapitre.id === this.chapitreCurrent.id);
            var videoIndex = this.chapitres.chapitres[chapitreIndex].videos.findIndex(video=>video.idYouTube === videoId);
            var videoInsert = JSON.parse(JSON.stringify( this.chapitres.chapitres[chapitreIndex].videos[videoIndex]));
            this.chapitres.chapitres[chapitreIndex].videos.splice(videoIndex-1, 0,videoInsert);
            this.chapitres.chapitres[chapitreIndex].videos.splice(videoIndex+1, 1);
            this.saveChapitre();
        },
        displayVideos(chapitre) {
            if (chapitre.id == this.chapitreCurrent.id)
                    this.chapitreCurrent = {
                        id: null
                    }
            else 
                this.chapitreCurrent = JSON.parse(JSON.stringify(chapitre));
        },
        addChapitre() {
            this.chapitres.chapitres.push(this.new_chapitre);
            this.saveChapitre();
        },
        openModalVideo() {
            this.editVideoJSON = {
                label: "",
                idYouTube: null
            }
            this.idYouTubeEdit = null;
            this.modalVideo = true;
        },
        saveVideoCredit(video) {
            var idElement = null;
            var maj = false;
            firebase_api.api.getDb().collection("videos").doc("video_credit").get().then(res=>{
                var videos = res.data();
                
                videos.videos.forEach((element, index) => {
                    if (element.id == video.idYouTube && video.credit)
                        idElement = index;
                });
                if (idElement != null) {
                    videos.videos.splice(idElement, 1);
                    maj = true;
                }
                if (video.credit && idElement==null) {
                    videos.videos.push({
                        id: video.idYouTube,
                        idYouTube: video.idYouTube
                    })
                    maj = true;
                }
                if (maj)
                    firebase_api.api.getDb().collection("videos").doc("video_credit").update({
                            videos: videos.videos
                })    
            })
            
        },
        saveVideo() {
            var chapitre = this.chapitres.chapitres.find(chapitre=>chapitre.id === this.chapitreCurrent.id);
            if (typeof(chapitre.videos)=="undefined")
                chapitre.videos = [];
            var idVideo = chapitre.videos.findIndex(video=>video.idYouTube === this.idYouTubeEdit)
            if (idVideo == -1)
                chapitre.videos.push(JSON.parse(JSON.stringify(this.editVideoJSON)));
            else
                chapitre.videos[idVideo] = JSON.parse(JSON.stringify(this.editVideoJSON));
            this.saveVideoCredit(this.editVideoJSON);
            this.saveChapitre();
            this.modalVideo = false;
        },
        editVideo(video) {
            this.idYouTubeEdit = video.idYouTube;
            this.editVideoJSON = JSON.parse(JSON.stringify(video));
            this.modalVideo = true;
        },
        removeVideo(video) {
            var bool = confirm("On supprime la vidéo?");
            if (bool) {
                var chapitreId = this.chapitres.chapitres.findIndex(chapitre=>chapitre.id === this.chapitreCurrent.id);
                var idVideo =  this.chapitres.chapitres[chapitreId].videos.findIndex(video=>video.idYouTube === video.idYouTube);
                this.chapitres.chapitres[chapitreId].videos.splice(idVideo, 1);
                this.saveChapitre();
            }
           
        },
        removeChapitre(chapitre) {
            var bool = confirm("On supprime ce chapitre ?");
            if (bool) {
                var chapitreId = this.chapitres.chapitres.findIndex(chapitre=>chapitre.id === chapitre.id);
                this.chapitres.chapitres.splice(chapitreId, 1);
                this.saveChapitre();
            }
           
        },
        saveChapitre() {
             firebase_api.api.getDb().collection("videos").doc("chapitres").update({
                chapitres: this.chapitres.chapitres
             }).then(res=>{
                this.refresh();
            });
        }
    }

})
</script>
